import { IInitUser } from '@/store/user/user';
import { StatusError } from './interfaces';
import { ApiResponse } from '@gry-dmitrij/api-request';
import request from './request';

interface ILoginData {
  captcha: string,
  memberId: string,
  password: string,
  token: string
}

export const login = (userData: ILoginData): Promise<IInitUser | StatusError> => {
  return request('post', '/api/users/login', userData)
    .then(({ data }) => data)
}

interface ISsoData {
  memberId: string,
  otp: string
}

export const loginBySso = (data: ISsoData): Promise<IInitUser | StatusError> => {
  return request('post', '/api/users/login-by-otp', {
    ...data
  })
    .then(({ data }) => data)
}

export interface IAuthData {
  accessToken: string,
  memberId: string,
}

export const AUTHENTICATE_PATH = '/api/users/authenticate'

interface IAuthResponse extends Omit<IInitUser, 'accessToken'> {
  token: string
}

export const authenticate = async(authData: IAuthData): Promise<ApiResponse<IAuthResponse>> => {
  return request('post', AUTHENTICATE_PATH, authData)
}

interface CaptchaResponse {
  data: string,
  token: string
}

export const getCaptcha = (): Promise<CaptchaResponse> => {
  return request('post', '/api/users/captcha')
    .then(data => {
      return data.data
    })
}

interface ILoginAsMember {
  memberId: string
}

export const loginAsMember = ({ memberId }: ILoginAsMember): Promise<IInitUser> => {
  return request('post', '/api/users/login-as-member', { memberId })
    .then(data => {
      return data.data
    })
}

interface GetSmsCodeProps {
  captcha: string
  captchaToken: string
  phone: string
}

interface SmsCodeResponse {
  token: string
}

export const getSmsCode = async({ captcha, captchaToken, phone }: GetSmsCodeProps): Promise<string> => {
  const { data }: ApiResponse<SmsCodeResponse> = await request(
    'post',
    '/api/signup',
    {
      captcha,
      token: captchaToken,
      phone
    }
  )
  return data.token
}

interface RepeatSmsCodeProps {
  phone: string
  token: string
}

export const repeatSmsCode = async({ phone, token }: RepeatSmsCodeProps): Promise<string> => {
  const { data }: ApiResponse<SmsCodeResponse> = await request(
    'post',
    '/api/signup/repeat',
    {
      phone,
      token
    }
  )
  return data.token
}

interface ConfirmSmsCodeProps {
  phone: string
  code: string
  token: string
}

export const confirmSmsCode = async(
  {
    phone,
    code,
    token
  }: ConfirmSmsCodeProps
): Promise<void> => {
  return request(
    'post',
    '/api/signup/sms',
    {
      phone,
      code,
      token
    }
  ).then()
}

interface CreateAccountProps {
  phone: string
  code: string
  token: string
  password: string
  name: string
  inviteCode: string
  email?: string
}

export const createAccount = async(props: CreateAccountProps): Promise<IInitUser> => {
  const { data }: ApiResponse<IInitUser> = await request(
    'post',
    '/api/signup/send',
    props
  )
  return data
}
